// extracted by mini-css-extract-plugin
export default {"wrapper":"MainMenu_wrapper__tRha9","container":"MainMenu_container__1KaWp","infosContainer":"MainMenu_infosContainer__75eEi"};